import {
    VENDOR_PROGRESSBAR_VIEW_REQUEST, VENDOR_PROGRESSBAR_VIEW_FAIL, VENDOR_PROGRESSBAR_VIEW_SUCCESS
  } from "../constants/AuthConstant";
  
  const initialState = {
    loading: false,
    action: "Home Action",
    result: [],
    msg: "",
    error: "",
  };
  
  const VendorProfileProgressBarReducer = (state = initialState, action) => {
    switch (action.type) {
      case VENDOR_PROGRESSBAR_VIEW_REQUEST:
        return {
          ...state,
          loading: action.payload,
        };
      case VENDOR_PROGRESSBAR_VIEW_SUCCESS:
        return {
          ...state,
          result: action.result.data,
          loading: action.payload,
          msg: action.msg,
        };
      case VENDOR_PROGRESSBAR_VIEW_FAIL:
        return {
          ...state,
          error: action.error,
          loading: action.payload,
          msg: action.msg,
        };
      default:
        return state;
    }
  };
  
  export default VendorProfileProgressBarReducer;  